import { handleJsonResponse } from "./generic";

export const fetchLessonTests = (lessonId, successCallback, errorCallback) => {
  fetch(`/api/lesson/${lessonId}/tests`).then((response) =>
    handleJsonResponse(response, successCallback, errorCallback)
  );
};
